export default __webpack_public_path__ + "static/media/no-membership.a08a363a.png";